import { RpcErrorCode } from '../../errors/rpc.js';
export function getRpcErrorCode(error) {
    if (error.toLowerCase().startsWith('rate limit exceeded')) {
        return RpcErrorCode.ACCESS_DENIED;
    }
    return RpcErrorCode.MISC_ERROR;
}
//# sourceMappingURL=utils.js.map